import { render } from "./ZakatOrderDetail.vue?vue&type=template&id=76043c02"
import script from "./ZakatOrderDetail.vue?vue&type=script&lang=js"
export * from "./ZakatOrderDetail.vue?vue&type=script&lang=js"
script.render = render

export default script